import { all, put, takeEvery } from "redux-saga/effects";
import { resetAnagrafeStateAction } from "../anagrafe/actions";
import { resetMessaggioStateAction, resetSnackbarStateAction } from "../messaggio/actions";
import { resetProfilazioneStateAction } from "../profilazione/actions";
import { resetScreeningStateAction } from "../screening/actions";
import { resetAuthStateAction } from "../auth/actions";
import { RESET_STATE, RESET_STATE_WITHOUT_AUTH } from "./actionsType";
import { resetScreeningColonRettoStateAction } from "../screeningColonRetto/actions";
import { resetPostLoginActionSuccess } from "../postLogin/actions";
import { generaLog } from "../../functions/utils";

function* handleResetStateWorker() {
    generaLog("handleResetStateWorker", "log")
    yield put(resetAnagrafeStateAction())
    yield put(resetMessaggioStateAction())
    yield put(resetSnackbarStateAction())
    yield put(resetProfilazioneStateAction())
    yield put(resetScreeningStateAction())
    yield put(resetScreeningColonRettoStateAction())
    yield put(resetPostLoginActionSuccess())

    yield put(resetAuthStateAction())
}

function* handleResetStateWatcher() {
    yield takeEvery(RESET_STATE, handleResetStateWorker)
}

function* handleResetStateWithoutAuthWorker() {
    generaLog("handleResetStateWithoutAuthWorker", "log")
    yield put(resetAnagrafeStateAction())
    yield put(resetMessaggioStateAction())
    yield put(resetSnackbarStateAction())
    yield put(resetProfilazioneStateAction())
    yield put(resetScreeningStateAction())
    yield put(resetScreeningColonRettoStateAction())
    yield put(resetPostLoginActionSuccess())
}

function* handleResetStateWithoutAuthWatcher() {
    yield takeEvery(RESET_STATE_WITHOUT_AUTH, handleResetStateWithoutAuthWorker)
}

export function* resetWatchers() {
    yield all([
        handleResetStateWatcher(),
        handleResetStateWithoutAuthWatcher(),
    ]);
}
